var _a;
import { MealName } from '@marketing/content';
var sectionTitle = 'Whole Food Ingredients';
var allIngredients = {
    beef: {
        name: 'beef',
        description: 'High in protein',
    },
    lamb: {
        name: 'lamb',
        description: 'A highly digestible protein',
    },
    pork: {
        name: 'pork',
        description: 'A highly digestible protein',
    },
    turkey: {
        name: 'turkey',
        description: 'A digestible protein',
    },
    chicken: {
        name: 'chicken',
        description: 'A lean protein',
    },
    squash: {
        name: 'squash',
        description: 'A great source of essential vitamins',
    },
    mushrooms: {
        name: 'mushrooms',
        description: 'A good source of selenium',
    },
    greenBeans: {
        name: 'green beans',
        description: 'Low-calorie + high fiber',
    },
    potatoes: {
        name: 'potatoes',
        description: 'A healthy carbohydrate',
    },
    sweetPotatoes: {
        name: 'sweet potatoes',
        description: 'A healthy carbohydrate',
    },
    spinach: {
        name: 'spinach',
        description: 'Contains calcium',
    },
    kale: {
        name: 'kale',
        description: 'Rich in antioxidants',
    },
    brownRice: {
        name: 'brown rice',
        description: 'A healthy carbohydrate',
    },
    eggs: {
        name: 'eggs',
        description: 'Rich in fatty acids',
    },
    carrots: {
        name: 'carrots',
        description: 'Contains beta-carotene',
    },
    peas: {
        name: 'peas',
        description: 'Packed with iron and zinc',
    },
};
export var ingredientsCarouselSectionContent = (_a = {},
    _a[MealName.Beef] = {
        title: sectionTitle,
        ingredients: [
            allIngredients.beef,
            allIngredients.potatoes,
            allIngredients.eggs,
            allIngredients.carrots,
            allIngredients.peas,
        ],
    },
    _a[MealName.Lamb] = {
        title: sectionTitle,
        ingredients: [
            allIngredients.lamb,
            allIngredients.brownRice,
            allIngredients.eggs,
            allIngredients.carrots,
            allIngredients.peas,
        ],
    },
    _a[MealName.Pork] = {
        title: sectionTitle,
        ingredients: [
            allIngredients.pork,
            allIngredients.potatoes,
            allIngredients.greenBeans,
            allIngredients.squash,
            allIngredients.kale,
            allIngredients.mushrooms,
        ],
    },
    _a[MealName.Turkey] = {
        title: sectionTitle,
        ingredients: [
            allIngredients.turkey,
            allIngredients.brownRice,
            allIngredients.carrots,
            allIngredients.spinach,
            allIngredients.eggs,
        ],
    },
    _a[MealName.Chicken] = {
        title: sectionTitle,
        ingredients: [
            allIngredients.chicken,
            allIngredients.sweetPotatoes,
            allIngredients.squash,
            allIngredients.spinach,
        ],
    },
    _a[MealName.TurkeyChicken] = {
        title: sectionTitle,
        ingredients: [
            allIngredients.turkey,
            allIngredients.chicken,
            allIngredients.sweetPotatoes,
            allIngredients.kale,
            allIngredients.eggs,
            allIngredients.peas,
        ],
    },
    _a);
